import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, FolderKanban, Settings, LogOut, MonitorPlay, Bot, Server, Terminal, Link, Gauge, BookOpen, Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/instances', icon: MonitorPlay, label: 'Instances' },
  { to: '/operator', icon: Gauge, label: 'Operator' },
  { to: '/agents', icon: Bot, label: 'Agents' },
  { to: '/agent-skills', icon: Sparkles, label: 'Agent Skills' },
  { to: '/runners', icon: Server, label: 'Runners' },
  { to: '/ssh-hosts', icon: Terminal, label: 'SSH Hosts' },
  { to: '/relay', icon: Link, label: 'Relay' },
  { to: '/projects', icon: FolderKanban, label: 'Projects' },
  { to: '/docs', icon: BookOpen, label: 'Docs' },
  { to: '/settings', icon: Settings, label: 'Settings' },
];

export default function AppLayout() {
  const { isLoading, logout } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="text-slate-400">Loading...</div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-slate-50">
      <aside className="flex w-64 flex-col border-r border-slate-200 bg-white">
        <div className="flex h-16 items-center gap-2 border-b border-slate-200 px-6">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-900 text-sm font-bold text-white">
            A
          </div>
          <span className="text-lg font-semibold text-slate-900">Aldan MCP</span>
        </div>

        <nav className="flex-1 space-y-1 p-4">
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }: { isActive: boolean }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-slate-100 text-slate-900'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                }`
              }
            >
              <Icon className="h-5 w-5" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-slate-200 p-4">
          <button
            onClick={logout}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900"
          >
            <LogOut className="h-5 w-5" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
